import * as React from 'react';
import { connect } from 'react-redux';
import {
  DoPbiAdminSearch,
  SetActiveReport,
  DeleteReport,
  SaveReportSharing,
} from './redux-objects/actions';
import { getUserAdminInfo } from '../Administration/redux-objects/actions';
import DataTable from '../DataTable';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { Button, Row, Modal } from 'react-bootstrap';
import * as urls from '../shared/urls';
import ReactDOM from 'react-dom';
import {
  IPbiReport,
  IPbiUserReport,
  IPbiReportEmbedding,
  IPbiRoleReport,
} from './business-objects/types';
import {
  RoleInfo,
  Permission,
  UserInfo,
} from '../Login/common/defaults';
import { toast } from 'react-toastify';
import { confirm } from 'react-bootstrap-confirmation';
import { isGranted, isGrantedAny, permissions } from '../../services/permissionChecker';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface IPowerBiAdminStateProps {
  users: UserInfo[];
  roles: RoleInfo[];
  permissions: Permission[];
  serviceURL: string;
  currentUser: UserInfo;
  reports: IPbiReport[];
  history: any;
}
export interface IPowerBiAdminActionProps {
  DoPbiAdminSearch?: (url: string) => Promise<void>;
  SetActiveReport?: (report: IPbiReport) => Promise<void>;
  DeleteReport?: (url: string, report: IPbiReport) => Promise<void>;
  getUserAdminInfo: (url: string, active: boolean) => Promise<void>;
  SaveReportSharing: (url: string, report: IPbiReport) => Promise<void>;
}

interface IPowerBiAdminProps
  extends IPowerBiAdminActionProps,
  IPowerBiAdminStateProps { }

interface IPowerBiAdminState {
  createdByMe: boolean;
  sharedWithMe: boolean;
  allReports: boolean;
  showDeleted: boolean;
  showModal: boolean;
  showPinModal: boolean;
  sharingReport: IPbiReport;
}

const initialState = {
  createdByMe: true,
  sharedWithMe: true,
  allReports: false,
  showDeleted: false,
  showModal: false,
  sharingReport: null,
  showPinModal: false,
};

type PowerBiAdminState = Readonly<typeof initialState>;

class PowerBiAdmin extends React.Component<
  IPowerBiAdminProps,
  IPowerBiAdminState
> {
  public constructor(props: IPowerBiAdminProps) {
    super(props);
    this.state = initialState;
  }

  // Should use DB to populate list, if we ever get more than one location to pin to
  pinLocations = [{ id: 1, name: 'Dashboard' }];

  componentDidMount() {
    this.doSearch();

    if (isGrantedAny([permissions.PowerBIShareReport, permissions.PowerBIShareAllReports], this.props.currentUser)) {
      this.props.getUserAdminInfo(urls.GET_USER_ADMIN_INFO, true);
    }
  }

  doSearch() {
    let uri = urls.POWERBI_ADMIN_SEARCH;
    var params = {
      createdByMe: this.state.createdByMe,
      sharedWithMe: this.state.sharedWithMe,
      allReports: this.state.allReports,
      showDeleted: this.state.showDeleted,
    };

    var esc = encodeURIComponent;
    var query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;

    this.props.DoPbiAdminSearch(uri);
  }

  handleCreate = () => {
    this.props.history.push('/CreateReport');
  };

  handleView = (event: React.MouseEvent<HTMLElement>, rowData: any) => {
    this.props.SetActiveReport(rowData).then(() => {
      this.props.history.push('/ViewReport');
    });
  };

  handleEdit = (event: React.MouseEvent<HTMLElement>, rowData: any) => {
    this.props.SetActiveReport(rowData).then(() => {
      this.props.history.push('/EditReport');
    });
  };

  handleDelete = async (event: React.MouseEvent<HTMLElement>, rowData: any) => {
    const result = await confirm('Are you sure you want to delete forever?');
    if (result == true) {
      this.doDelete(rowData);
    }
  };

  doDelete = (rowData: any) => {
    this.props.DeleteReport(urls.POWERBI_DELETE_REPORT, rowData).then(() => {
      toast.info(`Report ${rowData.name} Deleted`);
    });
  };

  handleCreatedByMeCheck(isChecked) {
    this.setState({ createdByMe: isChecked }, () => {
      this.doSearch();
    });
  }
  handleSharedWithMeCheck(isChecked) {
    this.setState({ sharedWithMe: isChecked }, () => {
      this.doSearch();
    });
  }
  handleAllReportsCheck(isChecked) {
    this.setState({ allReports: isChecked }, () => {
      this.doSearch();
    });
  }
  handleShowDeletedCheck(isChecked) {
    this.setState({ showDeleted: isChecked }, () => {
      this.doSearch();
    });
  }

  handleShareReport(event: React.MouseEvent<HTMLElement>, rowData: IPbiReport) {
    this.setState({
      showModal: true,
      sharingReport: rowData,
    });
  }

  async handlePinReport(
    event: React.MouseEvent<HTMLElement>,
    rowData: IPbiReport
  ) {
    // const result = await confirm('Pin Report to Dashboard?');
    // if (result == true) {
    //   this.doPin(rowData);
    // }
    this.setState({
      showPinModal: true,
      sharingReport: rowData,
    });
  }

  doPin = (rowData: IPbiReport) => {
    console.log('pin');
  };

  handleSavePin = () => {
    //Save
    this.props
      .SaveReportSharing(
        urls.POWERBI_SAVE_REPORT_SHARING,
        this.state.sharingReport
      )
      .then(() => {
        this.closePinModal();
        toast.success('Saved!');
      });
  };

  closeModal = (e?) => {
    this.setState({
      showModal: false,
      sharingReport: null,
    });
  };
  closePinModal = (e?) => {
    this.setState({
      showPinModal: false,
      sharingReport: null,
    });
  };

  handleSaveSharing = () => {
    //Save
    this.props
      .SaveReportSharing(
        urls.POWERBI_SAVE_REPORT_SHARING,
        this.state.sharingReport
      )
      .then(() => {
        this.closeModal();
        toast.success('Saved!');
      });
  };

  handleShareWithUser = (isChecked: boolean, userId: number) => {
    if (isChecked) {
      if (
        !this.state.sharingReport.pbiUserReports.some((x) => x.userId == userId)
      ) {
        const newUserReport: IPbiUserReport = {
          pbiReportId: this.state.sharingReport.id,
          userId: userId,
          canEdit: false,
          sharedById: this.props.currentUser.id,
        };
        this.setState(
          {
            sharingReport: {
              ...this.state.sharingReport,
              pbiUserReports: [
                ...this.state.sharingReport.pbiUserReports,
                newUserReport,
              ],
            },
          },
          () => {
            console.log('new shared report', this.state.sharingReport);
          }
        );
      }
    }
    if (!isChecked) {
      this.setState(
        {
          sharingReport: {
            ...this.state.sharingReport,
            pbiUserReports: [
              ...this.state.sharingReport.pbiUserReports.filter(
                (x) => x.userId != userId
              ),
            ],
            pbiReportEmbeddings: [
              ...this.state.sharingReport.pbiReportEmbeddings.filter(
                (x) => x.userId != userId
              ),
            ],
          },
        },
        () => {
          console.log('new shared report', this.state.sharingReport);
        }
      );
    }
  };

  handleUserCanEdit = (isChecked: boolean, userId: number) => {
    this.setState(
      {
        sharingReport: {
          ...this.state.sharingReport,
          pbiUserReports: this.state.sharingReport.pbiUserReports.map((x) =>
            x.userId != userId ? x : { ...x, canEdit: isChecked }
          ),
        },
      },
      () => {
        console.log('new shared report', this.state.sharingReport);
      }
    );
  };

  handleUserPinDashboard = (isChecked: boolean, userId: number) => {
    if (isChecked) {
      if (
        !this.state.sharingReport.pbiReportEmbeddings.some(
          (x) => x.userId == userId
        )
      ) {
        const newEmbedding: IPbiReportEmbedding = {
          pbiReportId: this.state.sharingReport.id,
          userId: userId,
          pbiLocationId: 1,
        };
        this.setState(
          {
            sharingReport: {
              ...this.state.sharingReport,
              pbiReportEmbeddings: [
                ...this.state.sharingReport.pbiReportEmbeddings,
                newEmbedding,
              ],
            },
          },
          () => {
            console.log('new shared report', this.state.sharingReport);
          }
        );
      }
    }
    if (!isChecked) {
      this.setState(
        {
          sharingReport: {
            ...this.state.sharingReport,
            pbiReportEmbeddings: [
              ...this.state.sharingReport.pbiReportEmbeddings.filter(
                (x) => x.userId != userId
              ),
            ],
          },
        },
        () => {
          console.log('new shared report', this.state.sharingReport);
        }
      );
    }
  };

  handleUserPin = (isChecked: boolean, userId: number, locationId: number) => {
    if (isChecked) {
      if (
        !this.state.sharingReport.pbiReportEmbeddings.some(
          (x) => x.userId == userId
        )
      ) {
        const newEmbedding: IPbiReportEmbedding = {
          pbiReportId: this.state.sharingReport.id,
          userId: userId,
          pbiLocationId: locationId,
        };
        this.setState(
          {
            sharingReport: {
              ...this.state.sharingReport,
              pbiReportEmbeddings: [
                ...this.state.sharingReport.pbiReportEmbeddings,
                newEmbedding,
              ],
            },
          },
          () => {
            console.log('new shared report', this.state.sharingReport);
          }
        );
      }
    }
    if (!isChecked) {
      this.setState(
        {
          sharingReport: {
            ...this.state.sharingReport,
            pbiReportEmbeddings: [
              ...this.state.sharingReport.pbiReportEmbeddings.filter(
                (x) => x.userId != userId && x.pbiLocationId != locationId
              ),
            ],
          },
        },
        () => {
          console.log('new shared report', this.state.sharingReport);
        }
      );
    }
  };

  handleShareWithRole = (isChecked: boolean, roleId: number) => {
    if (isChecked) {
      if (
        !this.state.sharingReport.pbiRoleReports.some((x) => x.roleId == roleId)
      ) {
        const newRoleReport: IPbiRoleReport = {
          pbiReportId: this.state.sharingReport.id,
          roleId: roleId,
          canEdit: false,
          sharedById: this.props.currentUser.id,
        };
        this.setState({
          sharingReport: {
            ...this.state.sharingReport,
            pbiRoleReports: [
              ...this.state.sharingReport.pbiRoleReports,
              newRoleReport,
            ],
          },
        });
      }
    }
    if (!isChecked) {
      this.setState({
        sharingReport: {
          ...this.state.sharingReport,
          pbiRoleReports: [
            ...this.state.sharingReport.pbiRoleReports.filter(
              (x) => x.roleId != roleId
            ),
          ],
        },
      });
    }
  };

  handleRoleCanEdit = (isChecked: boolean, roleId: number) => {
    this.setState({
      sharingReport: {
        ...this.state.sharingReport,
        pbiRoleReports: this.state.sharingReport.pbiRoleReports.map((x) =>
          x.roleId != roleId ? x : { ...x, canEdit: isChecked }
        ),
      },
    });
  };

  public render() {
    const columnDefs = [
      {
        targets: 0,
        width: '250px',
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleView(cellData, rowData)}
              >
                {' '}
                <i className='fas fa-eye'></i>
                View
              </Button>
              {'  '}
              {(isGranted(permissions.PowerBIEditAllReports, this.props.currentUser) || // if granted, can always edit
                ((rowData &&                                                            // otherwise, must be owner or shared with permission
                  rowData.pbiUserReports &&
                  rowData.pbiUserReports.some(
                    (x) =>
                      x.createdById == this.props.currentUser.id ||
                      (x.userId == this.props.currentUser.id && x.canEdit)
                  )) ||
                  (rowData &&
                    rowData.pbiUserReports &&
                    rowData.pbiRoleReports.some(
                      (x) =>
                        x.canEdit &&
                        this.props.currentUser.userRoles.some(
                          (y) => y.role.name == x.role.name
                        )
                    ))) && isGrantedAny([permissions.PowerBIEditReport], this.props.currentUser)) && (
                  <Button
                    variant='outline-warning'
                    size='sm'
                    data-id={cellData}
                    onClick={(e) => this.handleEdit(cellData, rowData)}
                  >
                    <i className='fas fa-edit'></i>
                    Edit
                  </Button>
                )}
              {'  '}
              {(isGranted(permissions.PowerBIDeleteAllReports, this.props.currentUser) || ((rowData &&
                rowData.pbiUserReports &&
                rowData.pbiUserReports.some(
                  (x) =>
                    x.createdById == this.props.currentUser.id ||
                    (x.userId == this.props.currentUser.id && x.canEdit)
                )) ||
                (rowData &&
                  rowData.pbiRoleReports &&
                  rowData.pbiRoleReports.some(
                    (x) =>
                      x.canEdit &&
                      this.props.currentUser.userRoles.some(
                        (y) => y.role.name == x.role.name
                      )
                  ))) &&
                (isGranted(permissions.PowerBIDeleteReport, this.props.currentUser))) && (
                  <Button
                    variant='outline-danger'
                    size='sm'
                    data-id={cellData}
                    onClick={(e) => this.handleDelete(cellData, rowData)}
                  >
                    <i className='fas fa-trash'></i> Delete
                  </Button>
                )}
              {'  '}
              <br />
              {(isGranted(permissions.PowerBIShareAllReports, this.props.currentUser) || ( // can share all reports
                rowData?.createdById == this.props.currentUser.id                          // or can share reports they created
                && isGranted(permissions.PowerBIShareReport, this.props.currentUser))) && (
                  <Button
                    variant='secondary'
                    size='sm'
                    data-id={cellData}
                    className='mt-10'
                    onClick={(e) => this.handleShareReport(cellData, rowData)}
                  >
                    <i className='fa fa-share-alt'></i> Share
                  </Button>
                )}
              {'  '}
              <Button
                variant='secondary'
                size='sm'
                data-id={cellData}
                className='mt-10'
                onClick={(e) => this.handlePinReport(cellData, rowData)}
              >
                <i className='fas fa-thumb-tack'></i> Pin
              </Button>

              {'  '}
            </div>,
            td
          ),
      },
    ];

    let columns = [
      {
        title: '',
        data: 'id',
      },
      {
        title: 'Report Name',
        data: 'name',
      },
      {
        title: 'Created By',
        data: 'createdBy.username',
      },
      {
        title: 'Shared By',
        mData: (data) => {
          var sharedByUserList = data.pbiUserReports.filter(
            (x) =>
              x.userId == this.props.currentUser.id && x.sharedByUser != null
          );
          if (sharedByUserList.length > 0) {
            var sharedByPerson = sharedByUserList[0].sharedByUser.username;
            return sharedByPerson;
          }
          var sharedByRoleList = data.pbiRoleReports.filter(
            (x) =>
              this.props.currentUser.userRoles.some(
                (item) => item.role.id == x.roleId
              ) && x.sharedByUser != null
          );
          if (sharedByRoleList.length > 0) {
            var sharedByPerson = sharedByRoleList[0].sharedByUser.username;
            return sharedByPerson;
          }
          return '';
        },
      },
      {
        title: 'Type',
        data: 'reportType.name',
      },
    ];

    if (this.state.showDeleted) {
      columns.push({ title: 'Active', data: 'active' });
    }

    const options = {
      dom: 'frtip',
    };

    return (
      <div>
        <Form>
          <Row>
            <Col xs={3}>
              <h2>Power BI Reports</h2>
            </Col>
            <Col xs={6}>
              <Form.Row>
                <Form.Group controlId='chkCreatedByMe'>
                  <Form.Check
                    type='checkbox'
                    label=' Created By Me'
                    checked={this.state.createdByMe}
                    onChange={(e) =>
                      this.handleCreatedByMeCheck(e.target.checked)
                    }
                  />
                </Form.Group>
                &nbsp;&nbsp;&nbsp;
                <Form.Group controlId='chkSharedWithMe'>
                  <Form.Check
                    type='checkbox'
                    label=' Shared With Me'
                    checked={this.state.sharedWithMe}
                    onChange={(e) =>
                      this.handleSharedWithMeCheck(e.target.checked)
                    }
                  />
                </Form.Group>
                &nbsp;&nbsp;&nbsp;
                {(isGrantedAny([permissions.PowerBIViewAllReports], this.props.currentUser)) && (
                  <Form.Group controlId='chkAllReports'>
                    <Form.Check
                      type='checkbox'
                      label=' All Reports'
                      checked={this.state.allReports}
                      onChange={(e) =>
                        this.handleAllReportsCheck(e.target.checked)
                      }
                    />
                  </Form.Group>
                )}
              </Form.Row>
            </Col>
            <Col xs={3}>
              {(isGrantedAny([permissions.PowerBICreateReport], this.props.currentUser)) && (
                <Button
                  variant='primary'
                  size='lg'
                  onClick={(e) => this.handleCreate()}
                  className='pull-right'
                >
                  {' '}
                  <i className='fa fa-plus'></i> Create Report
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col>
              {this.props.reports && (
                <DataTable
                  id='tblPowerBiReports'
                  data={this.props.reports}
                  columns={columns}
                  columnDefs={columnDefs}
                  actionsColumn='first'
                  select={false}
                  {...options}
                />
              )}
            </Col>
          </Row>
        </Form>
        <Modal
          show={this.state.showPinModal}
          onHide={this.closePinModal}
          dialogClassName='modal-report-pin'
        >
          <Modal.Header closeButton>
            <Modal.Title>Pin Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.sharingReport && (
              <Form>
                {this.pinLocations.map((x) => {
                  return (
                    <Row>
                      <Col>
                        <Form.Group controlId={'chkUserPin' + x.id}>
                          <Form.Check
                            type='checkbox'
                            label={'Pin to ' + x.name}
                            checked={this.state.sharingReport.pbiReportEmbeddings.some(
                              (y) =>
                                y.userId == this.props.currentUser.id &&
                                y.pbiLocationId == x.id
                            )}
                            onChange={(e) =>
                              this.handleUserPin(
                                e.target.checked,
                                this.props.currentUser.id,
                                x.id
                              )
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  );
                })}
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.closePinModal}>
              Close
            </Button>
            <Button variant='primary' onClick={this.handleSavePin}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showModal}
          onHide={this.closeModal}
          dialogClassName='modal-report-sharing'
        >
          <Modal.Header closeButton>
            <Modal.Title>Share Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.sharingReport && (
              <Form>
                <Row>
                  <Col>
                    <b>User</b>
                  </Col>
                  <Col>
                    <b>Share With</b>
                  </Col>
                  <Col>
                    <b>Can Edit</b>
                  </Col>
                  <Col>
                    <b>Pin to Dashboard</b>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
                {this.props.users.map((user) => {
                  console.log({ user });
                  return (
                    <Row key={'rowShareUser' + user.id}>
                      <Col>{user.username}</Col>
                      <Col>
                        <Form.Group controlId={'chkShareWithUser' + user.id}>
                          <Form.Check
                            type='checkbox'
                            label=' Shared'
                            disabled={
                              this.state.sharingReport.createdById == user.id
                            }
                            checked={this.state.sharingReport.pbiUserReports.some(
                              (y) => y.userId == user.id
                            )}
                            onChange={(e) =>
                              this.handleShareWithUser(e.target.checked, user.id)
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId={'chkUserCanEdit' + user.id}>
                          <Form.Check
                            type='checkbox'
                            label=' Edit'
                            disabled={
                              !this.state.sharingReport.pbiUserReports.some(
                                (y) => y.userId == user.id
                              ) || this.state.sharingReport.createdById == user.id
                            }
                            checked={this.state.sharingReport.pbiUserReports.some(
                              (y) => y.userId == user.id && y.canEdit
                            )}
                            onChange={(e) =>
                              this.handleUserCanEdit(e.target.checked, user.id)
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId={'chkUserPin' + user.id}>
                          <Form.Check
                            type='checkbox'
                            label=' Pinned'
                            disabled={
                              !this.state.sharingReport.pbiUserReports.some(
                                (y) => y.userId == user.id
                              ) || !isGranted(permissions.PowerBIViewAllReports, this.props.currentUser)
                            }
                            checked={this.state.sharingReport.pbiReportEmbeddings.some(
                              (y) => y.userId == user.id && y.pbiLocationId == 1
                            )}
                            onChange={(e) =>
                              this.handleUserPinDashboard(
                                e.target.checked,
                                user.id
                              )
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  );
                })}
                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <b>Role</b>
                  </Col>
                  <Col>
                    <b>Share With</b>
                  </Col>
                  <Col>
                    <b>Can Edit</b>
                  </Col>
                  <Col></Col>
                </Row>
                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
                {this.props.roles.map((x) => {
                  return (
                    <Row key={'rowShareRole' + x.id}>
                      <Col>{x.name}</Col>
                      <Col>
                        <Form.Group controlId={'chkShareWithrole' + x.id}>
                          <Form.Check
                            type='checkbox'
                            label=' Shared'
                            disabled={
                              this.state.sharingReport.createdById == x.id
                            }
                            checked={this.state.sharingReport.pbiRoleReports.some(
                              (y) => y.roleId == x.id
                            )}
                            onChange={(e) =>
                              this.handleShareWithRole(e.target.checked, x.id)
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId={'chkroleCanEdit' + x.id}>
                          <Form.Check
                            type='checkbox'
                            label=' Edit'
                            disabled={
                              !this.state.sharingReport.pbiRoleReports.some(
                                (y) => y.roleId == x.id
                              ) || this.state.sharingReport.createdById == x.id
                            }
                            checked={this.state.sharingReport.pbiRoleReports.some(
                              (y) => y.roleId == x.id && y.canEdit
                            )}
                            onChange={(e) =>
                              this.handleRoleCanEdit(e.target.checked, x.id)
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col></Col>
                    </Row>
                  );
                })}
                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.closeModal}>
              Close
            </Button>
            <Button variant='primary' onClick={this.handleSaveSharing}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    searchResults: state.PowerBI.reports,
    roles: state.Admin.roles,
    permissions: state.Admin.permissions,
    users: state.Admin.users,
    currentUser: state.Application.currentUser,
    reports: state.PowerBI.reports,
  };
}

const mapDispatchToProps = {
  DoPbiAdminSearch,
  SetActiveReport,
  DeleteReport,
  getUserAdminInfo,
  SaveReportSharing,
};

export default connect(mapStateToProps, mapDispatchToProps)(PowerBiAdmin);
